export function normalisePlainText(value) {
    return `${value ?? ""}`
        .replace(/&nbsp;|&#160;|&#xA0;/gi, " ")
        .replace(/\u00a0/g, " ")
        .replace(/\u200B/g, "")
        .trim()
}
